// These values must always be kept in sync with those of the less folder
// src/themes/RIO/css/mapping/numbers-map.scss

export const numbers = {
    from_0_to_100: ['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'],
};
